<template>
    <div class="map-container">
        <div class="map" :id="map_id"></div>
        <div class="map-control">
            <p class="text-primary">Lat: {{latLocale}}, Lng: {{lngLocale}}</p>
            <div class="location-button">
                <md-button class="md-raised md-secondary" @click="getLocation()" v-if="!disabled">
                    <template v-if="loading"><i class="material-icons button-icon rotate">loop</i></template>
                    <template v-if="!loading"><i class="material-icons button-icon">location_on</i> ចាប់យកទីតាំងបច្ចុប្បន្ន</template>
                </md-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            lat: {
                default: 11.574435
            },
            lng: {
                default: 104.899216
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                loading: false,
                map_id: "ID" + parseInt(Math.random() * 90000),
                map: null,
                marker: null,
                latLocale: this.lat,
                lngLocale: this.lng,
            }
        },

        methods: {
            getLocation() {
                this.loading = true;
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition((position) => {
                        let newLatLng = { lat: position.coords.latitude, lng: position.coords.longitude };
                        this.marker.setPosition(newLatLng);
                        this.map.setCenter(newLatLng);
                        this.setLocale(newLatLng);
                        this.$emit('locationUpdated', newLatLng);
                        this.loading = false;
                    });
                } else {
                    this.loading = false;
                }
            },
            setLocale(position) {
                this.latLocale = parseFloat(position.lat).toFixed(8);
                this.lngLocale = parseFloat(position.lng).toFixed(8);
            }
        },
        mounted() {

            let myLatlng = new google.maps.LatLng(this.latLocale, this.lngLocale);

            let mapOptions = { zoom: 14, center: myLatlng };
           
            this.map = new google.maps.Map(document.getElementById(this.map_id), mapOptions);

            if (this.disabled) {
                this.map.setOptions({ draggable: false, zoomControl: false, scrollwheel: false, disableDoubleClickZoom: true });
            }

            this.marker = new google.maps.Marker({
                position: myLatlng,
                map: this.map
            });

            this.marker.setMap(this.map);

            let self = this;

            google.maps.event.addListener(this.map, "center_changed", function () {
                if (!this.disabled) {
                    let lat = self.map.getCenter().lat();
                    let lon = self.map.getCenter().lng();
                    let newLatLng = { lat: lat, lng: lon };
                    self.marker.setPosition(newLatLng);
                    self.setLocale(newLatLng);
                    self.$emit('locationUpdated', newLatLng)
                }
            });
        }
    }
</script>
<style scoped>
    .map-container {
        width: 100%;
        text-align: right;
    }

    .map {
        height: 300px;
        width: 100%;
    }
    .map-control {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
    }
    .rotate {
		animation: rotation 1s infinite linear;
		-moz-animation: rotation 1s infinite linear;
		-webkit-animation: rotation 1s infinite linear;
	}

	@keyframes rotation {
		from {
			-webkit-transform: rotate(0deg);
		}

		to {
			-webkit-transform: rotate(359deg);
		}
	}

	@-moz-keyframes rotation {
		from {
			-webkit-transform: rotate(0deg);
		}

		to {
			-webkit-transform: rotate(359deg);
		}
	}

	@-webkit-keyframes rotation {
		from {
			-webkit-transform: rotate(0deg);
		}

		to {
			-webkit-transform: rotate(359deg);
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/LocationPicker.vue